import { camelCase, startCase } from 'lodash';

export const pascalCase = (str: string): string => {
    return startCase(camelCase(str)).replace(/ /g, '');
};

export const convertPascalCaseToKebabCase = (str: string): string => {
    return str.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();
};

export const EmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ValidateEmail = (email: string): boolean => {
    const result = EmailRegex.test(email);
    return result;
};
